import styled, { css } from "styled-components"

import Icon from "~/components/atoms/Icon"
import { Color, Transition } from "~/consts/style-mixins"

interface Props {
  size: keyof typeof SizeType
  isFavorited: boolean
  onClick: Function
  className?: string
}

export const SizeType = {
  Medium: "Medium",
  Small: "Small",
}

const iconSize = (size: keyof typeof SizeType): number => {
  switch (size) {
    case "Medium":
      return 24
    case "Small":
      return 16
  }
}

interface StyledProps {
  styledBySize: string
}

const styledBySize = {
  Medium: `
    width: 48px;
    height: 48px;
  `,
  Small: `
    width: 32px;
    height: 32px;
  `,
}

const FavoriteButton = ({ isFavorited, onClick, className, size }: Props) => {
  return (
    <StyledFavoriteButton className={className} styledBySize={styledBySize[size]} onClick={onClick as any}>
      <Icon
        size={iconSize(size)}
        type={isFavorited ? "FavoriteFill" : "FavoriteStroke"}
        color={isFavorited ? Color.Attention : Color.LightGray}
      />
    </StyledFavoriteButton>
  )
}

const StyledFavoriteButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: ${Color.White};
  cursor: pointer;
  border: 1px solid ${Color.BorderGray};
  ${Transition.Hover};
  svg {
    ${Transition.Hover};
  }
  &:hover {
    border: 1px solid ${Color.Attention};
    svg {
      fill: ${Color.Attention};
    }
  }
  ${({ styledBySize }: StyledProps) => css`
    ${styledBySize}
  `}
`

export default FavoriteButton
